import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import CustomInput from '../CommonComp/CustomInput/CustomInput';
import { editInvoiceClient } from '../../Services/OrderApis';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { action, logsMessagesList, modulesNames, tabNames, fieldNames } from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';

function EditInvoiceClientModal({ open, handleOpen, data, getListing }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (values, { resetForm }) => {
    setLoading(true)
    let resp = await editInvoiceClient(values);
    if (resp) {
      let payloadForLogs = {
        action: action?.update,
        module: modulesNames?.orders,
        tab: tabNames?.confirmed,
        description: logsMessagesList?.order?.confirmOrderInvoiceEdit,
        field_name: fieldNames?.client,
        old_value:  data?.client || "",
        new_value: values?.client || "",
        order_id: data?.order_id || "",
      };
      await adminAddLogs(payloadForLogs);
      resetForm({
        client: "",
        order_id: "",
      })
      getListing()
      handleOpen(false)
    }
    setLoading(false)
  };

  const formik = useFormik({
    initialValues: {
      client: data?.invoice?.client || "",
      order_id: data?.order_id || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      client: Yup.string().required('Client is required.'),
      order_id: Yup.string().required('Order id is required.')
    }),
    onSubmit: handleConfirm,
  });

  return (
    <div>
      <Dialog
        maxWidth={'md'}
        open={open}
        onClose={() => {
          handleOpen(false);
        }}
      >
        <DialogTitle variant='h3'>Edit Client Name</DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            onSubmit={formik.handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="orders_id"
                  label="Order Id"
                  placeholder="Order Id"
                  value={formik.values.order_id}
                  disabled
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.order_id && Boolean(formik.errors.order_id)}
                  helperText={formik.touched.order_id && formik.errors.order_id}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="client"
                  label="Client"
                  placeholder="Client"
                  value={formik.values.client}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.client && Boolean(formik.errors.client)}
                  helperText={formik.touched.client && formik.errors.client}
                />
              </Grid>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}>
              <CustomButton color={'buttonPrimary'} type="submit" loading={loading}>Confirm</CustomButton>
              <CustomButton
                onClick={() => {
                  formik.resetForm({
                    client: "",
                    order_id: "",
                  });
                  handleOpen(false)
                }
                }
                disabled={loading}
              >Cancel</CustomButton>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EditInvoiceClientModal;
